import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Chip,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Cancel, CheckCircle } from "@mui/icons-material";
import DeliveryDriverService from "services/DeliveryDriverService";
import { toCurrencyFormat } from "utils/formatter";
import CreateDepositModal from "./CreateDepositModal";
import toast from "react-hot-toast";

export const DeliveryDriversList: React.FC = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState<{ id: number; name: string; phone: string } | undefined>(
    undefined,
  );

  const { data: driversData, refetch } = DeliveryDriverService.useGetDeliveryDriversQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [verifyDriver] = DeliveryDriverService.useVerifyDeliveryDriverMutation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedDriverId, setSelectedDriverId] = useState<number | null>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, driverId: number) => {
    setAnchorEl(event.currentTarget);
    setSelectedDriverId(driverId);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedDriverId(null);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleOpenModal = (driver: any) => {
    console.log("driver", driver);
    setModalOpen(true);
    setSelectedDriver({
      id: driver.id,
      name: driver.user.name,
      phone: driver.user.phone,
    });
  };

  const handleVerifyClick = async (driverId: number) => {
    try {
      await verifyDriver(driverId).unwrap();
      refetch();
    } catch (error) {
      alert("Error al verificar el conductor");
    }
    handleCloseMenu();
  };

  const handleDepositSuccess = () => {
    toast.success("Deposito completado con exito");
    refetch();
    closeModal();
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Lista de conductores
      </Typography>
      <TableContainer component={Paper}>
        <Table aria-label="drivers table">
          <TableHead>
            <TableRow>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>Nombre</TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>Email</TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>Teléfono</TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>Estado</TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>Saldo</TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>Opciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {driversData?.map((driver) => (
              <TableRow key={driver.id}>
                <TableCell>{driver.user.name}</TableCell>
                <TableCell>{driver.user.email}</TableCell>
                <TableCell>{driver.user.phone}</TableCell>
                <TableCell>
                  {driver.isVerified ? (
                    <Chip label="Verificado" icon={<CheckCircle />} color="success" />
                  ) : (
                    <Chip label="Verificación pendiente" icon={<Cancel />} color="error" />
                  )}
                </TableCell>
                <TableCell component="th" scope="row">
                  <Typography variant="body1" color="textSecondary">
                    {toCurrencyFormat(driver.wallet?.currentBalance || 0)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Button variant="outlined" onClick={(e) => handleClick(e, driver.id)}>
                    Opciones
                  </Button>
                  <Menu anchorEl={anchorEl} open={open && selectedDriverId === driver.id} onClose={handleCloseMenu}>
                    {!driver.isVerified && <MenuItem onClick={() => handleVerifyClick(driver.id)}>Verificar</MenuItem>}
                    <MenuItem onClick={handleCloseMenu}>Detalles</MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleOpenModal(driver);
                      }}
                    >
                      Depositar
                    </MenuItem>
                  </Menu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {driversData && driversData && driversData.length === 0 && (
        <Alert severity="info">No hay conductores disponibles</Alert>
      )}
      {selectedDriver && (
        <CreateDepositModal
          isOpen={isModalOpen}
          handleClose={closeModal}
          isTransportDriver={false}
          id={selectedDriver.id}
          name={selectedDriver.name}
          phone={selectedDriver.phone}
          onSuccess={handleDepositSuccess}
        />
      )}
    </Box>
  );
};
